<template>
  <div class="coat">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/product/RAPheader.png" alt="" />
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="" />
        <span>首页 > 产品与解决方案>RPA解决方案</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="main">
      <div style="margin-bottom: 10px">方案概述</div>
      <p>RPA（Robotic Process Automation ）即机器人流程自动化，</p>
      <p>可以完美地取代人力的投入,高效完成重复且有逻辑 性的工作，</p>
      <p>解放人力，降本增效，并降低出错率。</p>
      <div class="title">应用场景</div>
      <div class="box">
        <div class="sections">
          <div class="section-title">贷款户财报自动录入</div>
          <div class="redfont">业务背景:</div>
          <div class="blackfont">
            情况分析，再录入到系统中内部编制了一些分析用Excel模版，但还需
            要由人工去适配客户的报表模版或完成纸质报表的手工转换
          </div>
          <div class="redfont" style="margin-top: 20px">效果价值：</div>
          <div class="blackfont">
            RPA机器人平均每笔业务处理时间由20分钟降至5分钟，90%操作工
            作由RPA独立完成，人工只需要做职业 判断即可每年约1万
          </div>
        </div>
        <div class="sections">
          <div class="section-title">发票批量核验</div>
          <div class="redfont">业务背景:</div>
          <div class="blackfont">
            财务每天需要登陆外网（增值税发票选择确认平台）拷贝网页发票数涉及到分页，
            拷贝完毕后筛选数据并放入模版Excel，再把文件拷贝
            到内网电脑，登陆（税务信息管理系统）上传
            表格；财务在此项工作中每天大概需要花费30分钟
          </div>
          <div class="redfont" style="margin-top: 20px">效果价值：</div>
          <div class="blackfont">
            内外网无缝打通：机器人通过外网获取原始数据，并随后切换内网进行数据核对与录入。
            自动化程度高：从内外网切换、各系统登录、数据核对等全过程自动化处理
            缩减人工：平均业务处理时间由30分钟降至3分钟，100%操作工作由RPA独立完成
          </div>
        </div>
        <div class="sections">
          <div class="section-title">监管上报</div>
          <div class="redfont">业务背景:</div>
          <div class="blackfont">
            随着金融形势的不断变化，监管统计政策日趋严格，监管报送智能化
            对于商业银行的重要意义逐步凸显监管统计工作的智能化程度与中小银行释放劳动力、降低差错率、提升数据质量的需求息息相关人工复
            核的传统方式已经开始制约中小银行的发展，监管统计工作的痛点主要有以下几个方面：监管报表涉及广、填报量大，人工填报易出错。
          </div>
          <div class="redfont" style="margin-top: 20px">效果价值：</div>
          <div class="blackfont">
            RPA机器人打通数据孤岛，实现报表数据的自动生成和填报，解决报
            表采用人工填报、无完善数 据仓库，无法实现自动取数等问题。
            通过引入机器人流程自动化（RPA）技术来实现资料的自动下载准备，
            解决报表复核需人工下载台账、报表等辅助资料存在耗时繁杂等问题。
            报表复核准确率大大提升，复核流程极度简化，复核时间大幅减少。
          </div>
        </div>
      </div>
      <div class="title">基础架构</div>
      <div>
        <img src="../assets/product/RAP1.png" alt="" />
      </div>
      <div class="title">功能架构</div>
      <div>
        <img src="../assets/product/RAP2.png" alt="" />
      </div>
      <div class="title">优势</div>
      <div>
        <img style="margin-left: 10%" src="../assets/product/RAP3.png" alt="" />
      </div>
      <div class="title">相关资料</div>
      <div class="flex">
        <img src="../assets/home/RPAZL.png" alt="" />
        <div style="width: 30%; text-align: left">
          <p class="flex-title">《RPA解决方案宣传册》</p>
          <p class="flex-font">
            机器人自动化流程，可以解决重复有规律的工作流问题，
            模拟人的操作从而代替人去自动完成任务以便提升人的 工作效率。
          </p>
          <div class="flex-button">敬请期待</div>
        </div>
      </div>
      <div class="title">售后服务及支持</div>
      <img src="../assets/product/RPA4.png" alt="" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  data() {
    return {};
  },
  mounted() {
    // this.request();
  },
  computed: {},
  methods: {
    request() {
      
      // 假设通过axios获取后端返回的文件数据流
      axios
        .get("/download?fileCode=RPA", {
          responseType: "blob", // 设置响应类型为blob
        })
        .then((response) => {
          console.log(response.status)
          // if(response.status==200){

          // }
          // 假设后端返回的文件数据流存储在response中
          // let blob = new Blob([response.data], { type: "application/pdf" });

          // let url = window.URL.createObjectURL(blob);
          // const link = document.createElement("a");
          // link.href = url;
          // link.setAttribute("download", "filename.pdf"); // 设置下载文件的文件名为filename.pdf
          // document.body.appendChild(link);
          // link.click();
          // window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error fetching file data:", error);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.coat {
  width: 100%;

  .section {
    margin: 0 0 -5px;
    position: relative;
    color: #ffffff;
    cursor: pointer;
    img {
      width: 100%;
      height: auto;
    }
  }
  // 内容提示
  .tips {
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div {
      margin-left: 12%;
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
      span {
        font-size: 10px;
        color: #808080;
        margin: 0 6px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  // 整体内容
  .main {
    width: 100%;
    background: #f5f5fa;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #405c80;
    padding: 60px 0;
    box-sizing: border-box;
    font-size: 28px;
    cursor: pointer;
    .title {
      margin: 60px auto;
    }
    .box {
      display: flex;
      width: 90%;
      margin: 10px 5%;
      justify-content: space-around;
      .sections {
        width: 30%;
        background-image: url("../assets/home/bg.png");
        padding: 5px;
        box-sizing: border-box;
        .section-title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 30px;
          color: #090909;
          margin: 10px auto;
        }
        .redfont {
          font-weight: bold;
          font-size: 14px;
          color: #ff0505;
          text-align: left;
        }
        .blackfont {
          font-weight: bold;
          font-size: 14px;
          color: #090909;
          text-align: left;
        }
      }
    }
    .flex {
      display: flex;
      justify-content: center;
      img {
        width: 30%;
        margin: 0 10px;
      }
      .flex-title {
        font-weight: bold;
        font-size: 30px;
        color: #405680;
      }
      .flex-font {
        font-weight: bold;
        font-size: 18px;
        color: #405680;
        margin: 40px auto 20px;
        text-align: left;
      }
      .flex-button {
        width: 100px;
        height: 35px;
        background: #1473eb;
        border-radius: 3px;
        text-align: center;
        line-height: 35px;
        font-weight: bold;
        font-size: 18px;
        color: #f1f4f8;
      }
    }
    p {
      color: #8d9bb9;
      font-size: 20px;
    }
    img {
      width: 55%;
      height: auto;
    }
  }
}
</style>
